import { Schema } from "effect";
import { MongoCustomerId } from "../ids/mongo-ids";

/**
 * Basic customer information for display in conversation lists and details.
 * Includes only the essential fields needed for UI rendering.
 */
export const CustomerBasicInfo = Schema.Struct({
  id: MongoCustomerId,
  displayName: Schema.String,
  firstName: Schema.NullOr(Schema.String),
  lastName: Schema.NullOr(Schema.String),
  email: Schema.NullOr(Schema.String),
  phone: Schema.NullOr(Schema.String),
});

export type CustomerBasicInfo = typeof CustomerBasicInfo.Type;
